module.exports = __webpack_public_path__ + "img/chef.be5030ca.webp";